import PropTypes from 'prop-types';
import React from 'react';
import config from './../../config';
import ReactTooltip from 'react-tooltip';
import { Card, CardBody, CardHeader } from 'shards-react';
import './WsiDisplay.css';
import wsiDimensions from './../../wsi_dimensions';

const bbox2ellipse = (bbox) => {
    // Cell bboxes use [left, top, right, bottom] image pixel coordinates.
    const xCenter = (bbox[0] + bbox[2]) / 2;
    const yCenter = (bbox[1] + bbox[3]) / 2;
    const xRadius = (bbox[2] - bbox[0]) / 2;
    const yRadius = (bbox[3] - bbox[1]) / 2;
    return [xCenter, yCenter, xRadius, yRadius];
};

const supportsWebp = () => {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
        // very old browser like IE 8, canvas not supported
        return false;
    }
};

const wsiOriginalSize = (wsi) => {
    if (wsi.pixelWidth && wsi.pixelHeight) {
        return {
            width: wsi.pixelWidth,
            height: wsi.pixelHeight,
        };
    }
    const wsiDims = wsiDimensions[String(wsi.id)];
    if(wsiDims) {
        return {
            width: wsiDims.width,
            height: wsiDims.height,
        };
    }
    if(wsi.datasetId <= 3) {
        return {
            width: 2560,
            height: 1920,
        };
    }
    if(wsi.datasetId === 47) {
        return {
            width: 2560,
            height: 2560,
        };
    } else if(wsi.datasetId === 48) {
        return {
            width: 2560,
            height: 2560,
        };
    } else if(wsi.datasetId === 49) {
        return {
            width: 2048,
            height: 1496,
        };
    } else if(wsi.datasetId === 50) {
        return {
            width: 1936,
            height: 1216,
        };
    } else if(wsi.datasetId === 51) {
        return {
            width: 1936,
            height: 1216,
        };
    } else if(wsi.datasetId === 52) {
        return {
            width: 1936,
            height: 1216,
        };
    } else if(wsi.datasetId === 53) {
        return {
            width: 2048,
            height: 1496,
        };
    } else if(wsi.datasetId === 54) {
        return {
            width: 250,
            height: 250,
        };
    } else if(wsi.datasetId === 55) {
        return {
            width: 2048,
            height: 2048,
    };
    } else if(wsi.datasetId === 56) {
        return {
            width: 2464,
            height: 2056,
        };
    } else {
        return {
            width: 2560,
            height: 2560,
        };
    }
};

// const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
const replaceExt = (path, newExt) => path.substr(0, path.lastIndexOf('.')+1) + newExt;

class WsiDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            colors: {},
        };
    }

    getColor(cell) {
        let r = 0,
            g = 0,
            b = 0;
        if (cell.lastAnnotationDate !== null) {
            // g = 255;
            //Math.floor(200+Math.random() * 55);
        } else {
            r = g = b = 64; //Math.floor(Math.random() * 128);
        }
        if (!this.state.colors[cell.id]) {
            let colors = this.state.colors;
            colors[cell.id] = `rgb(${r},${g},${b},1.0)`;
            // this.setState({ colors: colors });
        }
        /*
    } */
        return this.state.colors[cell.id];
    }

    render() {
        const { title, entityLabel, wsi, cells, selectedCell, onClick, pixelDiameterInMicrometer, loaded, useWebp, downsize } = this.props;
        const originalSize = wsiOriginalSize(wsi);
        const originalImgWidth = originalSize.width;
        const originalImgHeight = originalSize.height;
        const originalSuffix = wsi.ressourceUrl.split('.').pop();
        const wsiWebUrl = (wsi.webUrl.endsWith(".webp") && (!supportsWebp())) ? replaceExt(wsi.webUrl, originalSuffix) : wsi.webUrl;
        let header;
        if(title === '__HIDE__') {  
            header = false;
        } else if (title === '__PURE__') {
            header = title;
        } else {
            header = `${title} ${entityLabel}:${wsi.id} ds: ${wsi.datasetId}`
        }
        const selectedEllipse = selectedCell?.bbox ? bbox2ellipse(JSON.parse(selectedCell.bbox)) : null;
        return (
            <Card small>
                {header && (
                    <CardHeader className="border-bottom">
                        <h6 className="m-0">
                            {header}
                        </h6>
                        <div className="block-handle" />
                    </CardHeader>
                )}

                <CardBody className="border-top">
                    <div id="ref-container">
                        {loaded && (
                            <div id="wsi-svg-container">
                                <svg
                                    width={downsize ? '100%' : originalImgWidth}
                                    height={downsize ? undefined : originalImgHeight}
                                    viewBox={`0 0 ${originalImgWidth} ${originalImgHeight}`}
                                    style={{
                                        display: 'block',
                                        height: downsize ? 'auto' : originalImgHeight,
                                        backgroundImage: `url(${wsiWebUrl})`,
                                        backgroundSize: '100% 100%',
                                    }}
                                >
                                    <g>
                                        {cells.map((e, _) => {
                                            // let c = this.getColor(e);
                                            let boundaryPoints = JSON.parse(e.boundaryPoints);
                                            if (boundaryPoints === null) {
                                                const ellipse = bbox2ellipse(JSON.parse(e.bbox));
                                                return (
                                                    <ellipse
                                                        cx={ellipse[0]}
                                                        cy={ellipse[1]}
                                                        rx={(ellipse[2]) + 15}
                                                        ry={(ellipse[3]) + 15}
                                                        stroke={`rgb(255,0,0,1.0)`}
                                                        fill={`rgb(0,0,0,0.0)`}
                                                        strokeWidth="1"
                                                        data-tip
                                                        data-for={e.id}
                                                        key={e.id}
                                                        className={'cell' + (selectedCell === e ? ' selected' : '')}
                                                        onClick={(_e) => onClick(e)}
                                                    />
                                                )
                                            }
                                            return (
                                                    <polygon
                                                        stroke={`rgb(255,0,0,0.0)`}
                                                        fill={`rgb(255,0,0,0.0)`}
                                                        // fill={c}
                                                        //stroke={c}
                                                        strokeWidth="1"
                                                        data-tip
                                                        data-for={e.id}
                                                        key={e.id}
                                                        className={'cell' + (selectedCell === e ? ' selected' : '')}
                                                        onClick={(_e) => onClick(e)}
                                                        points={boundaryPoints
                                                            .map((p, _) => [p[1], p[0]])
                                                            .join(' ')}
                                                />
                                            )
                                        })}
                                    </g>
                                    {selectedEllipse && (
                                        <ellipse
                                            id="selected-element-bbox"
                                            cx={selectedEllipse[0]}
                                            cy={selectedEllipse[1]}
                                            rx={selectedEllipse[2] + 15}
                                            ry={selectedEllipse[3] + 15}
                                            stroke="red"
                                            strokeWidth="3"
                                            vectorEffect="non-scaling-stroke"
                                            fill="none"
                                            pointerEvents="none"
                                        />
                                    )}
                                </svg>
                                {cells.map((cell, i) => (
                                    <ReactTooltip key={cell.id} id={String(cell.id)} aria-haspopup="true">
                                        <div className="cell-tooltip__head">
                                            Cell {i + 1} of {cells.length}
                                        </div>
                                        <div className="cell-tooltip__data">
                                            <span>Last annotation: </span>
                                            <span>
                                                {cell.lastAnnotationDate !== null
                                                    ? 'On ' + cell.lastAnnotationDate
                                                    : 'Never'}
                                            </span>
                                            <span>Eccentricity:</span>
                                            <span>
                                                {cell.eccentricity !== null ? cell.eccentricity.toFixed(2) : ''}
                                            </span>
                                            <span>EquiDiameter:</span>
                                            <span>
                                                {(cell.equivalentDiameter * pixelDiameterInMicrometer).toFixed(2)}
                                                &#181;m
                                            </span>
                                            <span>Perimeter:</span>
                                            <span>
                                                {(cell.perimeter * pixelDiameterInMicrometer).toFixed(2)}&#181;m
                                            </span>
                                            <span>Area:</span>
                                            <span>
                                                {(cell.convexArea * Math.pow(pixelDiameterInMicrometer, 2)).toFixed(2)}
                                                &#181;m²
                                            </span>
                                            <span>Mean intensity:</span>
                                            <span>
                                                {cell.meanIntensity !== null ? cell.meanIntensity.toFixed(2) : ''}
                                            </span>
                                        </div>
                                    </ReactTooltip>
                                ))}
                            </div>
                        )}
                    </div>
                </CardBody>
            </Card>
        );
    }
}

WsiDisplay.propTypes = {
    title: PropTypes.string,
    entityLabel: PropTypes.string,
    /**
     * The component's title.
     */
    wsi: PropTypes.object,
    cells: PropTypes.array,
    loaded: PropTypes.bool,
    selectedCell: PropTypes.object,
    onClick: PropTypes.func,
    pixelDiameterInMicrometer: PropTypes.number,
};

WsiDisplay.defaultProps = {
    title: 'Img',
    entityLabel: 'wsi',
    loaded: false,
};

export default WsiDisplay;
